// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__a-+DW","footerLink":"Footer_footerLink__ewcQb","footerText":"Footer_footerText__ngtdp"};